import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PrimeReactProvider } from "primereact/api";
import { Amplify } from "aws-amplify";
import RouterApp from "./router/RouterApp";
import reportWebVitals from "./reportWebVitals";
import awsExports from "./aws-exports";
import "@aws-amplify/ui-react/styles.css";
import "primereact/resources/themes/lara-light-green/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "/node_modules/primeflex/primeflex.css";
// Design tokens (SYSTEM_DESIGN.md §3 y §5). Va DESPUÉS del tema de PrimeReact.
import "./styles/tokens.css";
// Marca #339966 + desacople de severidades (§3.1 y §3.2). Quitar este import
// revierte el cambio de color sin perder los tokens.
import "./styles/theme-overrides.css";
import "./styles/layout.css";
// import "/assets/css/custom-auth.css";
import { store } from "./store";
import CustomAuthenticator from "./CustomAuthenticator";
import { Toaster } from "react-hot-toast";
import { CometChatProvider } from "./CometChat/context/CometChatContext";
import { registerCalendarLocale } from "./utils/constants/calendar-constants";

registerCalendarLocale();

// Sin autocompletado del navegador en los campos del BO: la lista de textos ya escritos tapaba el
// formulario y, dentro de un modal, quedaba flotando al scrollear. Se aplica a InputText y, por
// dentro, a InputNumber y Calendar. El login es de Amplify y no pasa por acá.
const primeReactConfig = { pt: { inputtext: { root: { autoComplete: "off" } } } };

Amplify.configure(awsExports);
console.log(process.env["REACT_APP_API"]);

const App = () => {
  return (
    <CometChatProvider>
      <React.StrictMode>
        <Toaster
          position="top-center"
          containerStyle={{ zIndex: 99999 }}
          toastOptions={{
            style: {
              fontSize: '1.25rem',
              padding: '1.25rem',
              minWidth: '300px'
            }
          }}
        />
        <Provider store={store}>
          <PrimeReactProvider value={primeReactConfig}>
            <CustomAuthenticator>
              <RouterApp />
            </CustomAuthenticator>
          </PrimeReactProvider>
        </Provider>
      </React.StrictMode>
    </CometChatProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();